import { DefaultTestVerifiedPatient } from '../../models/verifiedPatient';
import { VerifyPatientAccessCodeResponse } from './verifyPatientAccessCodeResponse';

const mockData = {
  patientAccessCodeVerified: true,
  verifiedPatient: DefaultTestVerifiedPatient,
};

export const VerifyPatientAccessCodeServiceMock: VerifyPatientAccessCodeResponse =
  {
    data: mockData,
    succeeded: true,
    authorized: true,
  };
